import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class KpiService {
	deleteFailed = 'data delete failed' ; deleteSuccess = 'data delete success' ; insertFailed = 'data insert failed' ; dataFails = 'data fails' ; dataSuccess = 'data success'
	contentType = 'application/json, application/x-www-form-urlencoded;charset=ISO-8859-15'
  constructor(private readonly http : HttpClient) { }

	getByRegionDetails(regionID): Observable<any> {
		const httpCustomOptions = {
			headers: new HttpHeaders({
				'Content-Type': this.contentType,
				'Accept': 'application/json',
			})
		};
		return this.http
			.get(`${environment.baseAPIURL}/api/v1/kpi/byRegion/${regionID}`, httpCustomOptions)
			.pipe(
				tap(_ => this.log(this.dataSuccess)),
				catchError(this.handleError<any>(this.dataFails))
			);
  }

  getByTaskDetails(regionID1,regionID2): Observable<any> {
	const httpCustomOptions = {
		headers: new HttpHeaders({
			'Content-Type': this.contentType,
			'Accept': 'application/json',
		})
	};
	return this.http
		.get(`${environment.baseAPIURL}/api/v1/kpi/byTask/${regionID1},${regionID2}`, httpCustomOptions)
		.pipe(
			tap(_ => this.log(this.dataSuccess)),
			catchError(this.handleError<any>(this.dataFails))
		);
}

getByLateReasonDetails(periodID1,periodID2): Observable<any> {
	const httpCustomOptions = {
		headers: new HttpHeaders({
			'Content-Type': this.contentType,
			'Accept': 'application/json',
		})
	};
	return this.http
		.get(`${environment.baseAPIURL}/api/v1/kpi/byLateReason/${periodID1},${periodID2}`, httpCustomOptions)
		.pipe(
			tap(_ => this.log(this.dataSuccess)),
			catchError(this.handleError<any>(this.dataFails))
		);
}


getByOtherReasonDetails(periodID1,periodID2): Observable<any> {
	const httpCustomOptions = {
		headers: new HttpHeaders({
			'Content-Type': this.contentType,
			'Accept': 'application/json',
		})
	};
	return this.http
		.get(`${environment.baseAPIURL}/api/v1/kpi/byOtherReason/${periodID1},${periodID2}`, httpCustomOptions)
		.pipe(
			tap(_ => this.log(this.dataSuccess)),
			catchError(this.handleError<any>(this.dataFails))
		);
}

getLateReasonTotal(periodID1,periodID2): Observable<any> {
	const httpCustomOptions = {
		headers: new HttpHeaders({
			'Content-Type': this.contentType,
			'Accept': 'application/json',
		})
	};
	return this.http
		.get(`${environment.baseAPIURL}/api/v1/kpi/byLateReason/Total/${periodID1},${periodID2}`, httpCustomOptions)
		.pipe(
			tap(_ => this.log(this.dataSuccess)),
			catchError(this.handleError<any>(this.dataFails))
		);
}

getOtherReasonTotal(periodID1,periodID2): Observable<any> {
	const httpCustomOptions = {
		headers: new HttpHeaders({
			'Content-Type': 'application/json, application/x-www-form-urlencoded;charset=ISO-8859-15',
			'Accept': 'application/json',
		})
	};
	return this.http
		.get(`${environment.baseAPIURL}/api/v1/kpi/byOtherReasons/Total/${periodID1},${periodID2}`, httpCustomOptions)
		.pipe(
			tap(_ => this.log(this.dataSuccess)),
			catchError(this.handleError<any>(this.dataFails))
		);
}

  
	private handleError<T>(_operation, result?: T) {
		return (error: any): Observable<T> => {
			console.info(error); // log to console instead
			return of(result as T);
		};
	}

	/** Log a message */
	private log(message: string) {
		console.info('Message: ' + message);
	}



}
